<template>
  <action-menu-v2
    :teleport-menu="teleport"
    :offset="offset"
    :check-for-overflow="checkForOverflow"
    :icon-type="iconType"
    :close-menu-on-trigger-hide="closeMenuOnTriggerHide"
  >
    <template v-if="$slots.trigger" #trigger="slotProps">
      <slot name="trigger" v-bind="slotProps" />
    </template>
    <action-menu-item
      v-for="item in items"
      :key="item.label"
      :disabled="item.disabled"
      :class="[
        item.class,
        item.label === $t('COMMON.DELETE') ? 'text-error' : 'text-headline',
      ]"
      :data-cy="`menu-item-${item.label}`"
      @click="item.disabled ? undefined : item.handler()"
    >
      <icon-base
        v-if="item.icon"
        :icon="item.icon"
        :icon-color="item.color"
        class="mr-2 -ml-2"
      />
      <span>{{ item.label }}</span>
    </action-menu-item>
  </action-menu-v2>
</template>

<script lang="ts">
// Please check the comment inside the ActionMenuV2.vue component
import type { Offset } from "@/models/common";
import type { Component } from "vue";

export interface MenuItem {
  label: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  handler: (...args: any[]) => void;
  disabled?: boolean;
  class?: string;
  icon?: Component;
  color?: string;
}

interface Props {
  items: Array<MenuItem>;
  teleport?: boolean;
  teleportScrollable?: string;
  offset?: Offset;
  checkForOverflow?: boolean;
  iconType?: "vertical" | "horizontal";
  closeMenuOnTriggerHide?: boolean;
}
</script>

<script setup lang="ts">
import ActionMenuItem from "@/components/ui/ActionMenuItem.vue";
import ActionMenuV2 from "@/components/ui/ActionMenuV2.vue";
import IconBase from "@/components/ui/IconBase.vue";

const {
  items,
  teleport,
  offset,
  checkForOverflow,
  iconType = "vertical",
  closeMenuOnTriggerHide = false,
} = defineProps<Props>();
</script>
